"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _loginString = require("./loginString");
var _utils = require("./utils.js");
var _constants = require("./constants");
var LoginAnimate = exports["default"] = /*#__PURE__*/function () {
  function LoginAnimate() {
    (0, _classCallCheck2["default"])(this, LoginAnimate);
    var style = document.createElement('style');
    style.innerHTML = _loginString.styleStr;
    this.style = style;
    var loadingType = (0, _utils.getUrlParam)(window.location.href, 'loadingType');
    var loadingStr = _constants.EnumLoadingType[loadingType] || _loginString.juslinkLodingHtml;
    var template = "<div style=\"background-color: #f2f2f2;position: relative;height: 100vh;width: 100vw;\">".concat(loadingStr, "</div>");
    var loginContainerNode = document.createElement('div');
    loginContainerNode.innerHTML = template;
    loginContainerNode.style.position = 'absolute';
    loginContainerNode.style.transition = 'all .5s ease-in';
    loginContainerNode.style.opacity = '1';
    this.loginContainerNode = loginContainerNode;
  }
  return (0, _createClass2["default"])(LoginAnimate, [{
    key: "show",
    value: function show() {
      var first = document.body.firstChild;
      if (first) {
        document.body.insertBefore(this.style, first);
        document.body.insertBefore(this.loginContainerNode, first);
      } else {
        document.body.append(this.style);
        document.body.append(this.loginContainerNode);
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this = this;
      this.loginContainerNode.style.opacity = '0';
      setTimeout(function () {
        _this.style.remove();
        _this.loginContainerNode.remove();
      }, 500);
    }
  }]);
}();